import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Modal, toastEmitter } from "@anchor/react-components";
import Table from '@anchor/react-components/dist/lib/components/TableV2/Table'
import CONSTANTS from './SubscriptionConstants.js';
import { accessRequest } from './authConfig';
import useFetchWithMsal from './hooks/useFetchWithMsal';

function SubscriptionCodeTable({ code, value, type, counter }) {
    const { error, execute } = useFetchWithMsal(accessRequest);

    console.log('code1:' + code + ', value1:' + value + ', type1:' + type + ', counter:' + counter);

    const [data, setData] = useState('');
    const [selRec, setSelRec] = useState('');
    const [showDeleteModal, setDeleteModal] = useState('');

    const boxStyle = {
        justifyContent: "center",
        alignItems: "center", // Center vertically
        flexDirection: "column",
        width: "100%", // Set width to 100%
        background: "#fff",
        marginTop: "20px",
    };

    const tableColumns = [
        {
            slotKey: 'codeId',
            title: 'Code Id',
        },
        {
            slotKey: 'code',
            title: 'Code',
        },
        {
            slotKey: 'value',
            title: 'Value',
        },
        {
            slotKey: 'type',
            title: 'Type',
        }
    ];

    const fetchData = async () => {
        try {
            const urlstr = CONSTANTS.UI_BACKEND_BASE_URL + `/v1/subscriptionCode/getAllCodes?code=` + code + '&value=' + value + '&type=' + type;
            console.log(urlstr);

            execute("GET", urlstr).then((response) => {

                if (response) {
                    let jsonArray = response;
                    for (let i = 0; i < jsonArray.length; i++) {
                        let obj = jsonArray[i];
                        Object.keys(obj).map(function (key, index) {
                            if (key === 'value' && obj[key] == null) {
                                obj[key] = "<Null>";
                            }
                        });
                    }
                    console.log(jsonArray);
                    setData(jsonArray);
                }
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [counter, execute]);

    const handleDeleteButtonClick = async () => {
        console.log('Selected Records: ' + selRec);
        let ids = '';
        for (let i = 0; i < selRec.length; i++) {
            ids += selRec[i].codeId + ',';
        }

        try {
            const urlstr = CONSTANTS.UI_BACKEND_BASE_URL + `/v1/subscriptionCode/delete?ids=` + ids;
            console.log(urlstr);

            execute("DELETE", urlstr).then((response) => {
                if (response) {
                    console.log('response.status: ' + response.status);
                    console.log('response.message: ' + response.message);
                    if (response.status === 'OK' || response.status === 'CONFLICT') {
                        let respText = response.message;
                        if (response.status === 'OK') {
                            toastEmitter({ "title": "SUCCESS", "description": respText }, { position: 'top-center' });
                        } else {
                            toastEmitter({ "title": "ERROR", "description": respText }, { position: 'top-center', type: "error" });
                        }
                        setSelRec('');
                        fetchData();
                    } else {
                        if (response.status === 403) {
                            toastEmitter({ "title": "ERROR", "description": 'You are not authorized to delete Subscription Code(s).' }, { position: 'top-center', type: "error" });
                        } else {
                            toastEmitter({ "title": "ERROR", "description": 'Error occurred while deleting Subscription Code(s)' }, { position: 'top-center', type: "error" });
                        }
                    }
                }
            });
        } catch (error) {
            console.error("Error occurred while delete Subscription Code:", error);
        }
        setDeleteModal('')
    }

    return (
        <div >
            <div >
                <Table
                    stickyHeader
                    maxHeight={350}
                    // maxWidth={1000}
                    defaultColumns={tableColumns}
                    gridLine="both"
                    primaryKey="codeId"
                    fit="small"
                    tableWidth="full-width"
                    columnData={[
                        {
                            accessorKey: 'codeId',
                            header: 'Code Id',
                            id: 'codeId',
                        },
                        {
                            accessorKey: 'code',
                            alignData: 'right',
                            header: 'Code',
                            id: 'code',
                        },
                        {
                            accessorKey: 'value',
                            alignData: 'right',
                            header: 'Value',
                            id: 'value',
                        },
                        {
                            accessorKey: 'type',
                            alignData: 'right',
                            header: 'Type',
                            id: 'type',
                        }
                    ]}
                    defaultData={data}
                    onInputChange={function noRefCheck() { }}
                    onPageChange={function noRefCheck() { }}
                    onPageSizeOptionsChange={function noRefCheck() { }}
                    onRowClickCallback={function noRefCheck() { }}
                    onRowExpandedCallback={function noRefCheck() { }}
                    onRowSelection={function noRefCheck(e) {
                        setSelRec(e);
                    }}
                    onSorting={function noRefCheck() { }}
                    rowSelector={[
                        {
                            id: 'customSelect'
                        }
                    ]}
                />
            </div>
            <div style={boxStyle} >
                <Button
                    disabled={selRec.length === 0}
                    appearance="default"
                    id="primary2"
                    label="DELETE"
                    width="49"
                    name="primary2"
                    onClick={function noRefCheck() {
                        setDeleteModal(true)
                    }}
                    title="DELETE"
                    variant="filledAlt"
                    fit="small"
                />
                <Modal
                    actions={{
                        primaryAction: <Button variant="filledAlt" label="Yes, Delete" onClick={handleDeleteButtonClick} />,
                        tertiaryAction: <Button label="Cancel" onClick={function noRefCheck() { setDeleteModal('') }} variant="outlined" />
                    }}
                    heading="Alert"
                    dimension="small"
                    open={showDeleteModal}
                    showCloseIcon
                    onClose={function noRefCheck() { setDeleteModal('') }}
                >
                    <p>
                        Are you sure, you want to delete {selRec.length} subscription code(s)?
                    </p>
                </Modal>
            </div>
        </div>
    );
}

export default SubscriptionCodeTable;
